import styled from 'styled-components';
import { colors } from '@insurancemenu/imenu-components-lib';

export const InputRowStyled = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
`;

export const TitleStyled = styled.h3`
  font-size: 2.4rem;
  color: ${colors.neutral[900]};
  margin: 0 0 4rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;
